import type { ReactNode } from 'react';

import { useTheme } from '@emotion/react';

import { Typography } from '../../../../atoms/typography';
import { useBannerContext } from '../../banner.context';

import * as styles from './banner-subtitle.styles';

type Props = {
  children: ReactNode;
  className?: string;
};

export const BannerSubtitle = ({ children, className }: Props) => {
  const theme = useTheme();
  const { size } = useBannerContext();

  return (
    <Typography
      className={className}
      color="textPrimary"
      css={[styles.text, styles.textSize[size](theme), theme.presentation.banner.subtitle[size]]}
      fontWeight="regular"
      variant={size === 'medium' ? 'bodyMediumMobile' : 'b3'}>
      {children}
    </Typography>
  );
};
